export default {
  studio: 'Studio',
  deprecationDialog: {
    heading: 'Coming soon!',
    description:
      'We’re busy working on a brand new version of our customization tool.',
    description2:
      'Hopefully we’ll have something for you to play around with very soon!',
    action: 'Got it!',
  },
};
